/**
 * Region-aware phone validation for P1 (AU vs NZ).
 * Uses REACT_APP_P1_REGION so customer and admin forms validate correctly.
 */

export const isNzRegion = process.env.REACT_APP_P1_REGION === "NZ";

export const phoneValidationMessage = isNzRegion
  ? "Invalid New Zealand phone number"
  : "Invalid Australian phone number";

/** NZ mobile: 021/022/027/028/029 — national length 9–11 (incl. leading 0). */
export const NZ_MOBILE_REGEX = /^(\+?64|0)2[12789]\d{6,8}$/;

export function phoneValidationTest(value) {
  if (!value || typeof value !== "string") return false;
  const n = value.trim().replace(/\s/g, "");
  if (isNzRegion) return NZ_MOBILE_REGEX.test(n);
  return /^(?:\+?61|0)[2-478](?:[ -]?[0-9]){8}$/.test(n);
}

/** Default country label/value for address when no existing value (for forms). */
export const defaultCountryForRegion = isNzRegion
  ? { label: "New Zealand", value: "New Zealand" }
  : { label: "Australia", value: "Australia" };
